export function hasScrollBar() {
    return document.documentElement.scrollHeight > window.innerHeight;
}